import { type IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useMemo } from 'react';
import useAddFavorite from '~/hooks/vdp/favorites/useAddFavorite';
import { ListenerEvent, type ListenerEventType } from './constants';

type AddFavoritePayload = {
  stockNumber: number;
  vehicleId: number;
};

function isAddFavoriteMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, AddFavoritePayload> {
  return (
    message.event === ListenerEvent.AddFavorite &&
    message.payload.stockNumber != null &&
    message.payload.vehicleId != null
  );
}

export default function useAddFavoriteHandler(): MessageHandler<
  ListenerEventType,
  AddFavoritePayload
> {
  const addFavorite = useAddFavorite();

  return useMemo(
    () =>
      new MessageHandler(isAddFavoriteMessage, message => {
        void addFavorite(message.payload);
      }),
    [addFavorite]
  );
}
